// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1816":"319925e3","8179":"03e98b16"}[chunkId] + ".chunk.css";
};